module.exports = __webpack_public_path__ + "assets/7df3e364f3133a8bd0b2ad0f33874c13.png";